import axios from "axios";
import $ from "jquery";

const state = {
  operatorsStatistics: {},
  operator: {},
  operators: [],
  newOperators: [],
};

const getters = {
  operatorsStatistics(state) {
    return state.operatorsStatistics;
  },

  operator(state) {
    return state.operator;
  },

  operators(state) {
    return state.operators;
  },

  newOperators(state) {
    return state.newOperators;
  },
};

const mutations = {
  setOperatorsStatistics(state, statistics) {
    state.operatorsStatistics = statistics;
  },

  setOperator(state, operator) {
    state.operator = operator;
  },

  setOperators(state, operators) {
    state.operators = operators;
  },

  setNewOperators(state, operators) {
    state.newOperators = operators;
  },

  deleteNewOperator(state, id) {
    let index = state.newOperators.findIndex((o) => o.id == id);
    state.newOperators.splice(index, 1);
  },

  deleteOperator(state, id) {
    let index = state.operators.findIndex((o) => o.id == id);
    state.operators.splice(index, 1);
  },
};

const actions = {
  async fetchOperatorsStatistics({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/operator/statistics`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setOperatorsStatistics", res.data);
      });
  },

  async fetchOperator({ commit, rootState }, id) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/operator/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setOperator", res.data);
      });
  },

  async fetchOperators({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/operator/all`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setOperators", res.data);
      });
  },

  async fetchNewOperators({ commit, rootState }) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .get(`${apiUrl}/operator/new`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        commit("setNewOperators", res.data);
      });
  },

  async deleteOperator({ commit, dispatch, rootState }, data) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .delete(`${apiUrl}/operator/delete?id=${data.id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then(() => {
        $.alert("operator deleted successfull");

        if (data.flag === "new") {
          // delete new operator
          commit("deleteNewOperator", data.id);
        } else {
          // delete operator
          commit("deleteOperator", data.id);
        }

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async aproveOperator({ commit, dispatch, rootState }, id) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .put(
        `${apiUrl}/operator/aprove?id=${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(() => {
        $.alert("operator aproved successfull");
        commit("deleteNewOperator", id);

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async updateOperatorStatus({ dispatch, rootState }, data) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .put(
        `${apiUrl}/operator/status/update?id=${data.id}&status=${data.status}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(() => {
        $.alert("status updated successfull");

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async updateOperatorTag({ dispatch, rootState }, data) {
    dispatch("showSpinnerLoading", null, { root: true });

    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    await axios
      .put(
        `${apiUrl}/operator/tag/update?id=${data.id}&tag=${data.tag}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then(() => {
        $.alert("tag updated successfull");

        dispatch("hideSpinnerLoading", null, { root: true });
      });
  },

  async updateOperatorBasicInfo({ rootState }, data) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.put(`${apiUrl}/operator/basic-info/update`, data, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async updateOperatorDescription({ rootState }, data) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.put(`${apiUrl}/operator/description/update`, data, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async updateOperatorLogoBanner({ rootState }, data) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.put(`${apiUrl}/operator/logo-banner/update/${data.id}`, data.formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async updateOperatorCompanyDoc({ rootState }, data) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.post(`${apiUrl}/operator/document/add/${data.id}`, data.formData, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },

  async deleteOperatorCompanyDoc({ rootState }, id) {
    const apiUrl = process.env.VUE_APP_API_URL;
    const accessToken = rootState.authStore.token;

    return await axios.delete(`${apiUrl}/operator/document/delete?id=${id}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
